export default {
    //    apiKey: "AIzaSyByuM-kbhj57L0U4aRqe393xEEnlPi__RM",
    //     authDomain: "eshops.lk",
    //     databaseURL: "https://eshops-app.firebaseio.com",
    //     projectId: "eshops-app",
    //     storageBucket: "eshops-app.appspot.com",
    //     messagingSenderId: "789798668379"
    apiKey: "AIzaSyCuuV3HOuI_73rZiieYlLRIWOnO0y0FHyQ",
    authDomain: "eshops.lk",
    databaseURL: "https://eshopsapp.firebaseio.com",
    projectId: "eshopsapp",
    storageBucket: "eshopsapp.appspot.com",
    messagingSenderId: "591783300047",
    appId: "1:591783300047:web:8ff6f52aeb8ecc5b2220ba",
    measurementId: "G-ET8GNPSWL6"
}




// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js